import {
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { generatePath, Link } from 'react-router-dom';
import { CouponUseWhen } from '../../../../user-api/dist/src/entity/coupon.entity';
import { issueCouponAct } from '../../app/actions';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { appPath } from '../../router/AppRoute';
import { MyFooter } from '../footer/MyFooter';
import { MyAppBar } from '../appbar/MyAppBar';
import { useTranslation } from 'react-i18next';
import DATA_QA from '../../util/DataQaAttr';
import ExtraLink from './ExtraLink';

const handleDetailClick = () => {
  window.location.href = 'https://forms.gle/ThadoPG3eGtYnpd78';
};

export const InputAnswerCompleted = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const coupon = useAppSelector((state) => {
    return state.inputAnswer.session.cxHttpRes?.data?.cxShopToken?.cxCoupon;
  });

  const issueCouponStatus = useAppSelector((state) => {
    return state.inputAnswer.couponState!.issueCouponStatus;
  });

  const canClickGetCoupon =
    issueCouponStatus === 'idle' || issueCouponStatus === 'rejected';

  const handleGetCouponClicked = (e: React.MouseEvent) => {
    dispatch(issueCouponAct());

    return false;
  };

  let couponGetButton: JSX.Element | null;

  if (!coupon) {
    couponGetButton = null;
  } else {
    // 2022/05/19仕様変更。後日クーポンも即日クーポンと同じロジックで発行する。メアドを登録しない
    if (coupon.useWhen === CouponUseWhen.LATER && new Date().getTime() === 0) {
      const couponOrGetCouponPath = generatePath(appPath.shopqr.registerEmail);
      couponGetButton = (
        <Button
          variant="contained"
          color="primary"
          fullWidth
          component={Link}
          to={couponOrGetCouponPath}
          data-qa={DATA_QA.BUTTON.COUPON}
        >
          {t('question.earn_a_coupon')}
        </Button>
      );
    } else {
      couponGetButton = (
        <>
          <Box
            display="flex"
            position="relative"
            justifyContent="center"
            alignItems="center"
            mt={3}
          >
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleGetCouponClicked}
              disabled={!canClickGetCoupon}
              data-qa={DATA_QA.BUTTON.COUPON}
            >
              {t('question.earn_a_coupon')}
            </Button>
            {!canClickGetCoupon && (
              <Box
                position="absolute"
                top="50%"
                left="50%"
                style={{
                  transform: 'translate(-50%, -50%)',
                }}
              >
                <CircularProgress size="" />
              </Box>
            )}
          </Box>
        </>
      );
    }
  }

  return (
    <Container
      maxWidth={false}
      disableGutters={true}
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <MyAppBar />
      <Box mt={2} position="static" flexGrow="1">
        <Box mx={4} mt={4}>
          <Typography variant="h5">
            <Box fontWeight="fontWeightBold">
              {t('question.thank_you_for_responding')}
            </Box>
          </Typography>
        </Box>
        {!coupon && <ExtraLink sx={{ mt: 4, mx: 4 }} />}
        <Box mx={4} mt={4}>
          <Typography variant="h6">
            <Box>
              {t(
                'question.we_will_use_your_feedback_to_continue_making_our_service_better',
              )}
            </Box>
          </Typography>
        </Box>

        {/* 削除 begin */}
        <Box mx={4} mt={4} display="none">
          <Typography variant="h6">
            <Box>
              {t(
                'question.we_re_currently_looking_for_participants_for_a_survey_via_phone_in_hopes_to_improve_our_service',
              )}
            </Box>
          </Typography>
        </Box>
        <Box mx={4} mt={3} display="none">
          <Grid container>
            <Grid item xs={12}>
              <Box mx={3}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleDetailClick}
                >
                  {t('common.see_more')}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {/* 削除 end */}

        {coupon && (
          <Box mx={4} mt={3}>
            <Box mx={4} mt={4}>
              <Divider />
            </Box>
            <Grid container>
              <Grid item xs={12}>
                <Box mx={3}>{couponGetButton}</Box>
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>
      <MyFooter />
    </Container>
  );
};
